<template>
  <div class="home">
    <h1><!--{{ $t("Bonjour") }} <b id='utilisateurActu'></b>, -->{{ $t("Bienvenue sur votre espace") }} <b class="hight">Ooftop</b> {{ $t("bienvenue sur votre espace 2") }}</h1>
    <h2 class="mt-4 bold" v-if="infos_cli.dossier_create">{{ $t("Nouvelle commande") }}</h2>
    <p v-if="infos_cli.dossier_create">{{ $t("Comment choisir ma prestation") }} <a href="javascript:void(0)"><i class="icon-help-100"></i></a></p>
    <div class="row commande_links listing mb-2" v-if="infos_cli.dossier_create">
      <div class="col text-center p-3" v-if="infos_cli && infos_cli.menu && infos_cli.menu.filter(p=>(p.id=='menu_EVAL')).length">
        <a href="javascript:void(0)" @click="commander('evaluations')" id="home_evaluations_link" class="p-4">
          {{$t("Demander une "+infos_cli.menu.filter(p=>(p.id=='menu_EVAL'))[0].title)}}
          <i><img :src="require('../../assets/img/ICOS/menu_EVAL.svg')"/></i>
        </a>
      </div>
      <div class="col text-center p-3" v-if="infos_cli && infos_cli.menu && infos_cli.menu.filter(p=>(p.id=='menu_EXETR')).length">
        <a href="javascript:void(0)" @click="commander('evaluations_analyse')" id="home_evaluations_analyse_link" class="p-4">
          {{$t("Demander une "+infos_cli.menu.filter(p=>(p.id=='menu_EXETR'))[0].title)}}
          <i><img :src="require('../../assets/img/ICOS/menu_EXETR.svg')"/></i>
        </a>
      </div>
      <div class="col text-center p-3" v-if="infos_cli && infos_cli.menu && infos_cli.menu.filter(p=>(p.id=='menu_AVAL')).length">
        <a href="javascript:void(0)" @click="commander('avis_valeur')" id="home_avis_valeurs_link" class="p-4">
          {{$t("Commander un "+infos_cli.menu.filter(p=>(p.id=='menu_AVAL'))[0].title)}}
          <i><img :src="require('../../assets/img/ICOS/menu_AVAL.svg')"/></i>
        </a>
      </div>
      <div class="col text-center p-3" v-if="infos_cli && infos_cli.menu && infos_cli.menu.filter(p=>(p.id=='menu_EXIM')).length">
        <a href="javascript:void(0)" @click="commander('expertises_immobilieres')" id="home_expertises_immobilieres_link" class="p-4">
          {{$t("Commander une "+infos_cli.menu.filter(p=>(p.id=='menu_EXIM'))[0].title)}}
          <i><img :src="require('../../assets/img/ICOS/menu_EXIM.svg')"/></i>
        </a>
      </div>
      <div class="col text-center p-3" v-if="infos_cli && infos_cli.menu && infos_cli.menu.filter(p=>(p.id=='menu_DOCL')).length">
        <a href="javascript:void(0)" @click="commander('documents_legaux')" id="home_documents_legaux_link" class="p-4">
          {{$t("Commander un "+infos_cli.menu.filter(p=>(p.id=='menu_DOCL'))[0].title)}}
          <i><img :src="require('../../assets/img/ICOS/menu_DOCL.svg')"/></i>
        </a>
      </div>
    </div>
    <Liste />
  </div>
</template>

<script>
  import Liste from '@/components/Liste'
  export default {
    name: "home",
    components: {
      Liste,
    },
    data () {
        return {
        }
    },
    mounted(){
      this.get_infos_cli();
    }
  };
</script>
